import { render, staticRenderFns } from "./DSContDatasourceAssignment.vue?vue&type=template&id=719f5550&lang=pug"
import script from "./DSContDatasourceAssignment.vue?vue&type=script&lang=js"
export * from "./DSContDatasourceAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('719f5550')) {
      api.createRecord('719f5550', component.options)
    } else {
      api.reload('719f5550', component.options)
    }
    module.hot.accept("./DSContDatasourceAssignment.vue?vue&type=template&id=719f5550&lang=pug", function () {
      api.rerender('719f5550', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/datastudio/DSContDatasourceAssignment.vue"
export default component.exports